import * as angular from 'angular';

export interface SecondaryTradeResource extends ng.resource.IResourceClass<
    ng.resource.IResource<SecondaryTradeDto>
> {
    dataPage: ng.resource.IResourceMethod<
        ng.resource.IResource<DataPageDto<SecondaryTradeDto>>
    >;
    acerSubmissions: ng.resource.IResourceMethod<
        ng.resource.IResource<AcerReportSubmissionDto[]>
    >;
}

function secondaryTradeResource(
    $resource: ng.resource.IResourceService,
    API_URL
): SecondaryTradeResource {
    return <SecondaryTradeResource>$resource(
        API_URL.SECONDARY_TRADE,
        {},
        {
            get: {
                method: 'GET',
                url: API_URL.SECONDARY_TRADE + '/:id',
                isArray: false
            },
            dataPage: {
                method: 'GET',
                isArray: false
            },
            acerSubmissions: {
                url: API_URL.SECONDARY_TRADE + '/acer-submissions',
                method: 'GET',
                params: {
                    channelType: '@channelType',
                    tradeId: '@id'
                },
                isArray: true
            }
        }
    );
}

angular.module('app').factory('SecondaryTrade', secondaryTradeResource);
